module.exports = __webpack_public_path__ + "media/mypage/images/flat/books-3df1849904630340b3edbf95256d9470.png";